/**
 * Use Unlink Document Hook
 *
 * Wraps the unlinkDocumentFromChecklistItem mutation using useApiMutation
 * for consistent error handling.
 */

import { api } from "convex/_generated/api";
import { useApiMutation } from "@/packages/features-shared";
import type { Id } from "@/packages/types";

export function useUnlinkDocument() {
  const mutation = useApiMutation(
    api.checklist_mutations.unlinkDocumentFromChecklistItem,
    {
      name: "unlink-document-from-checklist-item",
      successMessage: "Document unlinked",
    },
  );

  return (args: {
    documentId: Id<"documents">;
    checklistItemId: Id<"checklistItems">;
  }) => mutation.mutateAsync(args);
}
